import { useDebouncedValue } from '@mantine/hooks';
import useResizeObserver from '@react-hook/resize-observer';
import { useLayoutEffect, useState } from 'react';

export type UseSizeReturn = DOMRectReadOnly | undefined;

const useSize = (target): UseSizeReturn => {
    const [size, setSize] = useState<DOMRectReadOnly>();

    useLayoutEffect(() => {
        setSize(target.current.getBoundingClientRect());
    }, [target]);

    useResizeObserver(target, (entry) => setSize(entry.contentRect));
    return size;
};

export const useDebouncedSize = (target, delay = 100): UseSizeReturn => {
    const size = useSize(target);

    const [debouncedSize] = useDebouncedValue(size, delay);

    return debouncedSize;
};

export default useSize;
